import Vue from 'vue'
import VueResource from 'vue-resource'
import Api from './api'
import store from '@/store/index'
import mapper from './translate-mapper'

Vue.use(VueResource)

const allApi = {
  ...Api
}

// Note: Before Request
Vue.http.interceptors.push((request, next) => {
  // Note: Add custom headers
  request.headers.set('X-CSRF-TOKEN', 'TOKEN')
  request.headers.set('Accept', 'application/json')
  let token = store.getters['auth/token']
  if (token && token.accessToken) {
    request.headers.set('Authorization', 'Bearer ' + token.accessToken)
  }
  // TODO: This section must be removed when TenantId fetched from authorization header
  let tenantInfo = store.getters['tenantConfig/tenantInfo']
  if (tenantInfo && tenantInfo.id) {
    request.headers.set('TenantId', tenantInfo.id.toString())
    console.log()
    request.headers.set('TenantId', tenantInfo.id.toString())
  }

  next()
})

// Note: After Request
Vue.http.interceptors.push((request, next) => {
  // TODO: Fetch result from response and send back just result (response.body.result)
  next(function (response) {
    if (response.ok === false) {

    } else {
      // Note: Extract language specific data from translate object attached to response data
      if (response.body.result && response.body.result.items) {
        response.body.result.items = mapper.mapArray(response.body.result.items, store.getters['tenantConfig/defaultLanguageName'], store.getters['tenantConfig/fallbackLanguageName'])
      } else if (response.body.result && response.body.result.translates) {
        response.body.result = mapper.mapObject(response.body.result, store.getters['tenantConfig/defaultLanguageName'], store.getters['tenantConfig/fallbackLanguageName'])
      }
    }
  })
})

const Server = Vue.resource('', {}, allApi)
export default Server
